// store/actions/msgHandler.js
export default {
    // 统一消息处理入口
    handleRawMessage({ commit, state }, payload) {
        if (!payload) return;

        let messages = [];
        if (payload.messages) {
            messages = Array.isArray(payload.messages) ? payload.messages : [payload.messages];
        } else if (payload.data) {
            messages = Array.isArray(payload.data) ? payload.data : [payload.data];
        }

        if (!messages.length) return;

        // 按会话分组
        const messagesBySession = {};
        for (const msg of messages) {
            if (!msg?.guid) continue;
            const sessionId = msg.fromGuid === state.userGuid ? msg.targetGuid : msg.fromGuid;
            if (!sessionId) continue;
            if (!messagesBySession[sessionId]) messagesBySession[sessionId] = [];
            messagesBySession[sessionId].push(msg);
        }

        // 批量更新 - 使用 ADD_MESSAGES_TO_SESSION
        for (const [sessionId, msgs] of Object.entries(messagesBySession)) {
            commit('im/ADD_MESSAGES_TO_SESSION', { sessionId, messages: msgs, prepend: false }, { root: true });
        }

        setTimeout(() => {
            try {
                const EventBus = require('@/common/EventBus').EventBus;
                EventBus.$emit('sessions-updated');
            } catch (e) {
                // 静默失败，不影响主流程
                console.warn('[IM] 触发会话更新事件失败:', e);
            }
        }, 50);
    },
    // 处理消息已读状态更新
    handleMessageReadStatus({ commit, state }, { fromGuid, toGuid, msgGuids }) {
        if (!msgGuids || msgGuids.length === 0) return;

        const sessionId = toGuid;
        const session = state.sessionMap.get(sessionId);
        if (!session || !session.messages) return;

        let updated = false;
        const updatedMessages = session.messages.map(msg => {
            if (msgGuids.includes(msg.guid) && msg.readStatus !== 1) {
                updated = true;
                return { ...msg, readStatus: 1 };
            }
            return msg;
        });

        if (updated) {
            session.messages = updatedMessages;
            commit('SET_SESSION_MAP', new Map(state.sessionMap));

            try {
                const EventBus = require('@/common/EventBus').EventBus;
                EventBus.$emit('messages-read-status-updated', { sessionId });
            } catch (e) {
                // 静默失败，不影响主流程
                console.warn('[IM] 触发已读状态更新事件失败:', e);
            }
        }
    },
};